import { MPFStepFooterObject } from '../../../util/types';

// import './Step.scss';

/**
 * A Progress Bar Step component
 * @param props
 */
let SignpostStep = (props: MPFStepFooterObject) => {

  let classes = [
    'Step',
    `Step--${props.status}`,
  ];

  return (
    <div className={classes.join(' ')}>
      <div className='Step__dot'>
      </div>
      {/* TODO: use P or span or label? */}
      <p className="Step__label">{props.label}</p>
      {/* separate label for mobile */}
      <p className="Step__label Step__label--mobile">{props.mobileLabel ? props.mobileLabel : props.label}</p>
    </div>
  );
};

export default SignpostStep;
